import { Box, Stack } from '@chronosphereio/chrono-ui';

export interface ColorBarProps {
  colors: string[];
}

export function ColorBar({ colors }: ColorBarProps) {
  return (
    <Stack direction={'row'} alignContent={'center'} height="12px" width="100%" marginY="4px">
      {colors.map((color, index) => {
        let borderRadius = '0';
        if (index === 0) {
          borderRadius = '3px 0 0 3px';
        } else if (index === colors.length - 1) {
          borderRadius = '0 3px 3px 0';
        }

        return <Box key={index} flex={1} height="100%" bgcolor={color} borderRadius={borderRadius} />;
      })}
    </Stack>
  );
}
